import {
  GTG_TARGET_COUNTRY_KE,
  GTG_TARGET_COUNTRY_ES,
  GTG_TARGET_COUNTRY_TH,
  normalizeGtgTargetCountry,
  GTG_KENYA_COUNTIES,
} from "../constants/gtgGeoConstants";
import {
  GTG_SPAIN_PROVINCES,
  GTG_THAILAND_PROVINCES,
} from "../constants/gtgSpainThailandProvincesConstants";
import { parseKenyaCountiesText } from "./gtgKenyaCountiesParse";
import { parseSpainThailandProvincesText } from "./gtgSpainThailandProvincesParse";

/**
 * @param {unknown} targetCountry
 * @returns {readonly string[]}
 */
export function getGtgCanonicalSubdivisionList(targetCountry) {
  const c = normalizeGtgTargetCountry(targetCountry);
  if (c === GTG_TARGET_COUNTRY_KE) return GTG_KENYA_COUNTIES;
  if (c === GTG_TARGET_COUNTRY_ES) return GTG_SPAIN_PROVINCES;
  if (c === GTG_TARGET_COUNTRY_TH) return GTG_THAILAND_PROVINCES;
  return [];
}

/**
 * Same shape as `parseKenyaCountiesText` (`counties` = canonical subdivision names for Firestore `kenyaCounties`).
 * @param {string} text
 * @param {unknown} targetCountry
 * @returns {{ counties: string[], unknown: string[] }}
 */
export function parseSubdivisionsForTargetCountry(text, targetCountry) {
  const c = normalizeGtgTargetCountry(targetCountry);
  if (c === GTG_TARGET_COUNTRY_KE) {
    return parseKenyaCountiesText(text);
  }
  if (c === GTG_TARGET_COUNTRY_ES) {
    return parseSpainThailandProvincesText(text, GTG_SPAIN_PROVINCES);
  }
  if (c === GTG_TARGET_COUNTRY_TH) {
    return parseSpainThailandProvincesText(text, GTG_THAILAND_PROVINCES);
  }
  return { counties: [], unknown: [] };
}

/**
 * @param {Set<string>|ReadonlySet<string>} selectedSet
 * @param {unknown} targetCountry
 * @returns {string[]}
 */
export function orderedSubdivisionsFromSelectedSet(selectedSet, targetCountry) {
  const list = getGtgCanonicalSubdivisionList(targetCountry);
  return list.filter((x) => selectedSet.has(x));
}
